import React, { useState, useEffect } from "react";
import "../App.css";
import "../css/login.css";
import AppButtonLaunch from "./AppButtonLaunch";
import createHistory from "history/createBrowserHistory";

import styled from "styled-components";
import EmailForm from '../components/EmailForm';


const StyledLogin = styled.div`
  flex-direction: column;
  justify-content: center;
  display: flex;
  height: 100vh;
  width: 100%;
  align-items: center;
  background-color: ${props => props.theme.midnightBlue};
  font-family: ${props => props.theme.font};
  .loginCard {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 35px;
    border-radius: 8px;
    background-color: #ffffff;
    margin-bottom : 20px;
  
  }
  h3{ 
    text-align: center;
  }
  h6 {
    margin: 15px 40px 55px 40px;
    text-align: center;
  }

  h5{
    text-align: center;
  }
  .noMatch {
    font-family: ${props => props.theme.font};
    margin: 25px 0;
    font-size: 20px;
    text-align: center;
  }

  .form-width {
    width: 12.6;
  }
  .buttonClass {
    text-decoration: none;
    margin: 17px 20px 5px 20px;
    font-size: 10px;
    border: none;
    background-color: ${props => props.theme.midnightBlue};
    padding: 9px 16px;
    letter-spacing: 0.2px;
    color: #ffffff;
    border-radius: 30px;
    text-align: center;

    &:hover {
      opacity: 0.8;
    }
  }
  button {
    margin: 17px 0 5px 0;
    font-size: 18px;
    border: none;
    background-color: ${props => props.theme.midnightBlue};
    padding: 9px 16px;
    letter-spacing: 0.2px;
    color: #ffffff;
    border-radius: 30px;

    &:hover {
      opacity: 0.8;
    }
  }

  @keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeInDown {
  animation-name: fadeInDown;
}
`;
export const history = createHistory();


const Login = props => {
  const [emailBool, setEmailBool] = useState(false)
  const emailHelp = () => {
    // console.log('halp')
    setEmailBool(!emailBool)

  }
  return (
  <StyledLogin>
    {/* <div className="SampleBox img-responsive"> */}
    <div className="loginCard">
      <AppButtonLaunch />


       
        <a
          className="buttonClass"
          onClick={() => emailHelp()}
        >
          Email Support
        </a>
    </div>
    {/* </div> */}
  
  { emailBool &&   <EmailForm className='form-width' emailBool={emailBool}/> }

  </StyledLogin>
  )
}

export default Login;
